// extracted by mini-css-extract-plugin
export default {"imageContainer":"CardImage_imageContainer__QdFr9","image":"CardImage_image__wK+JP"};